import { Logger } from "aws-amplify"
const logger = new Logger("User Activity Mixin")
import { titleCase, getUserFriendlyDuration } from "@/utils"
import moment from "moment"

export const userActivity = {
  methods: {
    userActivityMap(item) {
      const map = {
        login: 'Login',
        successful: 'Successful',
      }

      return map.hasOwnProperty(item) ? map[item] : '';
    },

    $getUserActivityStatus (item) {
      return titleCase(item.context_status, true)
    },

    // returns formatted text to be displayed in the activity information of the reports page, and user activity popup
    $getUserActivityDescription(i, orgList = [], homeOrg = false) {
      let item = JSON.parse(JSON.stringify(i))

      try {
        logger.debug("map activity details", item)
        let activityType = this.$getUserActivity(item)
        const textStyle = `font-size: 12px !important; margin: 0 !important`
        const boldStyle = `font-size: 12px !important; margin: 0 !important; font-weight: 700`

        if(i.action == 'login') {
          return `<p style="${textStyle}"> ${item.context_message}` + ' </p>'
        } 

        let text = ''

        // if we have an org name to load we do so here.
        // we do not display this if the org is the same as the users home org, this should only show if the user was 
        // cross org browsing
        if(orgList.length && item.target_org && item.target_org !== homeOrg) {

          if(!this.orgMap) {
            this.orgMap = orgList.reduce((set, org) => {
              set[org.id] = org.name
              return set
            }, {})
          }

          text += `<p style="${textStyle}"><b style="${boldStyle}">Organisation:</b> ${this.orgMap[item.target_org] || item.target_org}` + ' </p>'
        }

        if(item.context_trackable_name && item.context_trackable_name != '\r') {
          text += `<p style="${textStyle}"><b style="${boldStyle}">Vehicle:</b> ${item.context_trackable_name}` + ' </p>'
        } else {
          logger.debug("get user activity 2", item, item.context_trackable_name, Object.keys(item))
        }
      
        // parsing array from a string :( :( :( :(
        // formatted funny so we make sure we don't have any leading or trailing quote marks, and then replace all the single quotes with doubles
        // if this for whatever reason fails, we just show the raw value of the string
        if(item.context_channels) {
          try {
            let string = item.context_channels
            let arrayStart = string.indexOf('[')
            let arrayEnd = string.indexOf(']')
            let stringSection = string.slice(arrayStart, arrayEnd+1).replaceAll("'", '"')
            let channels = JSON.parse(stringSection)
            
            if(channels[0] && channels[0].duration) {
              const userFriendlyDuration = getUserFriendlyDuration(channels[0].duration)
              let start = channels[0].start_time.includes('Z') ? channels[0].start_time.slice(0, -1) : channels[0].start_time
              text+= `<p style="${textStyle}"><b style="${boldStyle}">Start:</b> ${moment(start).format('MMM DD YYYY HH:mm:ss')}, <b>Duration:</b> ${userFriendlyDuration} </p>`
            } 
            
            else if(channels[0] && channels[0].start_time) {
              let start = channels[0].start_time.includes('Z') ? channels[0].start_time.slice(0, -1) : channels[0].start_time
              text+= `<p style="${textStyle}"><b style="${boldStyle}">Start:</b> ${moment(start).format('MMM DD YYYY HH:mm:ss')} </p>`
            }
            
            logger.debug("channel info", channels, item.context_channels)
            let channelsText = channels.map((chn) => `${chn.channel}: ${chn.name}`).join(', ')
            text += `<p style="${textStyle}"><b style="${boldStyle}">Channels:</b> ${channelsText} </p>`
          } 

          // incase parsing goes wrong
          catch (err) {
            logger.debug("could not parse channel info", err)
            text += `<p style="${textStyle}"><b style="${boldStyle}"Channel:</b> ${item.context_channels} </p>`
          }
        }

        if(item.context_target_user_emails && item.context_target_user_emails.length) {
          let string = item.context_target_user_emails
            let arrayStart = string.indexOf('[')
            let arrayEnd = string.indexOf(']')
            let stringSection = string.slice(arrayStart, arrayEnd+1).replaceAll("'", '"')
            let emails = JSON.parse(stringSection)

            let namesString = item.context_target_user_names
            let NameArrayStart = namesString.indexOf('[')
            let NameArrayEnd = namesString.indexOf(']')
            let NameStringSection = namesString.slice(NameArrayStart, NameArrayEnd+1).replaceAll("'", '"')
            let names = JSON.parse(NameStringSection)

            logger.debug("parsing user names", item, activityType, names)
          if(emails && emails.length && names && names.length) {
            emails = emails.map((email, index) => `${names[index]} (${email})`)
            let label = activityType == 'Share video'
              ? 'Shared with'
              : activityType == 'Unshare video'
                ? 'Unshared with'
                : 'Users'
            text += `<p style="${textStyle}"><b style="${boldStyle}">${label}:</b> ${emails.join(', ')} </p>`
          }
        }
        
        return text
      }

      catch (err) {
        logger.debug("error getting user activity", err, item)
        return '-'
      }
    },

    // returns the activity name for a given user activity object
    $getUserActivity(item) {
      const getAction = (actionName) => {
        logger.debug("getting item 2", actionName)
        const map = {
          login: 'Login',
          //accessed: 'Accessed Video',
          successful: 'Successful',
          'stream recorded video': 'Remote Video Playback',
          'stream live video': 'Live Video Streaming'
        }

        return actionName && actionName.length
          ? map[actionName] || titleCase(actionName, true)
          : titleCase(actionName, true)
      }
  
      return item.hasOwnProperty('context_activity_type') && item.context_activity_type.length
        ? getAction(item.context_activity_type.replaceAll('_', ' '))
        : getAction(item.action)
    }
  },
}